/* tslint:disable */
/* eslint-disable */
/**
 * Control Online API
 * Control Online API
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface FundLoanDtoFromFund
 */
export interface FundLoanDtoFromFund {
  /**
   *
   * @type {string}
   * @memberof FundLoanDtoFromFund
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof FundLoanDtoFromFund
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof FundLoanDtoFromFund
   */
  fundGroupId: string;
  /**
   *
   * @type {number}
   * @memberof FundLoanDtoFromFund
   */
  balance: number;
  /**
   *
   * @type {number}
   * @memberof FundLoanDtoFromFund
   */
  reserved: number;
  /**
   *
   * @type {boolean}
   * @memberof FundLoanDtoFromFund
   */
  archived: boolean;
}

export function FundLoanDtoFromFundFromJSON(json: any): FundLoanDtoFromFund {
  return FundLoanDtoFromFundFromJSONTyped(json, false);
}

export function FundLoanDtoFromFundFromJSONTyped(json: any, ignoreDiscriminator: boolean): FundLoanDtoFromFund {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    id: json["id"],
    name: json["name"],
    fundGroupId: json["fundGroupId"],
    balance: json["balance"],
    reserved: json["reserved"],
    archived: json["archived"],
  };
}

export function FundLoanDtoFromFundToJSON(value?: FundLoanDtoFromFund | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    id: value.id,
    name: value.name,
    fundGroupId: value.fundGroupId,
    balance: value.balance,
    reserved: value.reserved,
    archived: value.archived,
  };
}
